// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"e2330258","461":"1b7ae200","878":"feb5ca4f","925":"ac4e9706"}[chunkId] + ".chunk.css";
};